import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
import StatusTDModel from './StatusTDModel';
import StatusDocumentModel from './StatusDocumentModel';
export default class ReportCompleteLateModel extends BaseModel {

    constructor() {
        super({ 
                name: "reportCompleteLate",
                tableName: 'document', 
                label: "Báo cáo VB hoàn thành trễ", 
                display_key: 'code_system', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center", 
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            scan_barcode: {
                name: 'scan_barcode', 
                type: "Boolean",
                label: 'Đã in mã code',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            barcode: {
                name: 'barcode', 
                label: 'Đã in mã code',
                filter: { type: 'input', match: 'contains'},
                display: false,
                computed: (data) => {
                    data.barcode = '';
                    if(data.scan_barcode){
                        data.barcode = 1;
                    }
                }
            },
            code_system: {
                name: 'code_system', 
                type: "String",
                label: 'Mã VB hệ thống',
                width: 8,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_court: {
                name: 'code_court', 
                type: "String",
                label: 'Mã VB của tòa',
                width: 8,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_office: {
                name: 'code_office', 
                type: "String",
                label: 'Mã văn phòng',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            number_decision: {
                name: 'number_decision', 
                type: "String",
                label: 'Số quyết định',
                width: 8,
                filter: { type: 'input', match: 'contains'},
               // display: false
            },
            content_document: {
                name: 'content_document', 
                type: "String",
                label: 'Nội dung văn bản',
                width: 8,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            date_issued: {
                name: 'date_issued', 
                type: "Date",
                label: 'Ngày ban hành',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_invite: {
                name: 'date_invite', 
                type: "Date",
                label: 'Ngày mời',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            name_litigant: {
                name: 'name_litigant', 
                type: "String", 
                label: 'Tên đương sự', 
                width: 10,
                class: "center", 
                // sortable: false,
                filter: {  type: 'input', match: 'contains' },
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width: 9,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            ward_ref: { 
                refs: 'ward {id name}',
                display: false
            },
            display_ward: { 
                name: "display_ward", 
                label: "Phường / Xã",
                width: 6,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_ward = '';
                    if(data.ward !== undefined && data.ward !== null){
                        data.display_ward = data.ward.name;
                    }
                }
            },
            district_ref: { 
                refs: 'district {id name}',
                display: false
            },
            display_district: {
                name: "display_district", 
                label: "Quận / Huyện",
                width: 8,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_district = '';
                    if(data.district !== undefined && data.district !== null){
                        data.display_district = data.district.name;
                    }
                }
            },
            state_ref: { 
                refs: 'state {id name}',
                display: false
            },
            display_state: {
                name: "display_state", 
                label: 'Tỉnh / Thành phố',
                width: 9,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_state = '';
                    if(data.state !== undefined && data.state !== null){
                        data.display_state = data.state.name;
                    }
                }
            },
            phone_litigant: {
                name: 'phone_litigant', 
                type: "String",
                label: 'Số điện thoại',
                display: false
            },
            signer: {
                name: 'signer', 
                type: "String",
                label: 'Người ký',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            code_agency: {
                name: 'code_agency',
                type: "String",
                label: 'Mã cơ quan',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_area: {
                name: 'code_area',
                type: "String",
                label: 'Mã khu vực',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            date_receipt_court: {
                name: 'date_receipt_court', 
                type: "Date",
                label: 'Ngày nhận VB từ tòa',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_dpv_receipt: {
                name: 'date_dpv_receipt', 
                type: "Date",
                label: 'Ngày ĐPV nhận lại VB',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_request_complete: {
                name: 'date_request_complete', 
                type: "Date",
                label: 'Ngày yêu cầu hoàn thiện lại',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_complete: {
                name: 'date_complete', 
                type: "Date",
                //label: 'Ngày VB hoàn thành',
                label: 'Ngày hoàn thành VB',
                width: 10,
                class: "center",
                //filter: { type: 'input', match: 'contains'},
                filter: { type: 'DateRange', match: 'custom'},
                //display: false
            },
            date_return_court: {
                name: 'date_return_court', 
                type: "Date",
                label: 'Ngày trả tòa',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            type_document: {
                name: 'type_document', 
                type: "Selection",
                label: 'Loại VB',
                width: 6,
                class: "center", 
                options: [
                    { value: 1, label: '1', default: true },
                    { value: 2, label: '2'},
                    { value: 3, label: '3'},
                    { value: 4, label: '4'},
                    { value: 5, label: '5'}
                ],
                filter: { 
                    type: 'select', 
                    optionLabel: 'label', 
                    optionKey: 'value', 
                    match: 'equals' 
                },
                // display: false
            },
            is_urgent: {
                name: 'is_urgent', 
                type: "Boolean",
                label: 'VB gấp',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            custom_urgent: {
                name: 'custom_urgent', 
                label: 'VB gấp',
                width: 6,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.custom_urgent = '';
                    if(data.is_urgent){
                        data.custom_urgent = 'Gấp';
                    }
                }
            },
            tdv_ref: { 
                refs: 'tdv {id fullname phone}',
                display: false
            },
            display_tdv: {
                name: 'display_tdv', 
                label: 'Họ & tên TĐV',
                width: 8,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_tdv = '';
                    if(data.tdv !== undefined && data.tdv !== null){
                        data.display_tdv = data.tdv.fullname;
                    }
                }
            },
            date_tdv_receipt: {
                name: 'date_tdv_receipt', 
                type: "Date",
                label: 'Ngày TĐV nhận VB',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_change_tdv: {
                name: 'date_change_tdv', 
                type: "Date",
                label: 'Ngày đổi TDV',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            count_day_done: {
                name: 'count_day_done', 
                type: "Int",
                width: 8,
                class: "right",
                label: 'Tổng ngày hoàn thành VB',
               // filter: { type: 'input', match: 'contains'},
               // display: true
            },
            date_tdv_return: {
                name: 'date_tdv_return', 
                type: "Date",
                label: 'Ngày trả ĐPV',
                width: 10,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            vplk_ref: { 
                refs: 'office_vplk {id name code}',
                display: false
            },
            code_vplk: {
                name: 'code_vplk', 
                label: 'Mã VP liên kết',
                filter: { type: 'input', match: 'contains'},
                display: false,
                computed: (data) => {
                    data.code_vplk = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.code_vplk = data.office_vplk.code;
                    }
                }
            },
            /*code_area: {
                name: 'code_area', 
                type: "String",
                label: 'Mã Khu vực',
                filter: { type: 'input', match: 'contains'},
                display: false
            },*/
            status_td_ref: { 
                refs: 'status_tongdat {id name code delay_time}',
                display: false
            },
            // status_td_id: {
            //     name: 'status_td_id', 
            //     type: "Selection",
            //     label: 'Hình thức TĐ',
            //     options: [
            //         { value: 1, label: 'Trực tiếp', default: true },
            //         { value: 2, label: 'Trực tiếp (có xác nhận UB)'},
            //         { value: 3, label: 'Giao nhận'},
            //         { value: 4, label: 'Người thứ 3'},
            //         { value: 5, label: 'Người thứ 3 (có xác nhận UB)'},
            //         { value: 6, label: 'Niêm yết'},
            //         { value: 7, label: 'Không thành'},
            //         { value: 8, label: 'Trả lại tòa'}
            //     ],
            //     filter: { 
            //         type: 'select', 
            //         optionLabel: 'label', 
            //         optionKey: 'value', 
            //         match: 'equals' 
            //     },
            //     // display: false
            // },
            status_td_id: { 
                name: "status_td_id", 
                label: "Hình thức TĐ", 
                width: 10,
                type: "Selection",
                class: "center", 
                models: new StatusTDModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                // computed: (data) => {
                //     data.status_td_id = (data.status_tongdat !== undefined && data.status_tongdat !== null) ? data.status_tongdat.id : 0;
                // }
            },
            status_vb_ref: { 
                refs: 'status_document {id name ordinal}',
                display: false
            },
            // status_vb_id: {
            //     name: 'status_vb_id', 
            //     type: "Selection",
            //     label: 'Trạng thái VB',
            //     options: [
            //         { value: 1, label: 'VB chờ xác nhận', default: true },
            //         { value: 2, label: 'VB đã xác nhận'},
            //         { value: 3, label: 'VB đang TĐ'},
            //         { value: 4, label: 'VB đã trả ĐPV'},
            //         { value: 5, label: 'VB ĐPV đã nhận'},
            //         { value: 6, label: 'VB hoàn thiện lại'},
            //         { value: 7, label: 'VB hoàn thành'},
            //         { value: 9, label: 'VB đã trả cơ quan'},
            //         { value: 8, label: 'VB đã tính lương'},
            //     ],
            //     filter: { 
            //         type: 'select', 
            //         optionLabel: 'label', 
            //         optionKey: 'value', 
            //         match: 'equals' 
            //     },
            //     // display: false
            // },
            status_vb_id: { 
                name: "status_vb_id", 
                label: "Trạng thái VB", 
                width: 10,
                class: "center", 
                type: "Selection",
                models: new StatusDocumentModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                // computed: (data) => {
                //     data.status_td_id = (data.status_tongdat !== undefined && data.status_tongdat !== null) ? data.status_tongdat.id : 0;
                // }
            },
            cost_document: {
                name: 'cost_document', 
                type: "Int",
                label: 'Chi phí văn bản',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            is_fee_budget: {
                name: 'is_fee_budget', 
                type: "Int",
                label: 'Đối tượng chịu phí',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            reason_delay: {
                name: 'reason_delay', 
                type: "String",
                label: 'Lý do trễ',
                width: 8,
                class: "center", 
                // display: false
            },
            note: {
                name: 'note', 
                type: "String",
                label: 'Ghi chú',
                display: false
            },
            phone_tdv: {
                name: 'phone_tdv', 
                type: "String",
                label: 'SDT TĐV',
                display: false
            },
            is_import: {
                name: 'is_import', 
                type: "Int",
                label: 'Import file',
                display: false
            },
            is_confirmed: {
                name: 'is_confirmed', 
                type: "Checkbox",
                label: 'Xác nhận DPV đưa tay cho TDV',
                display: false
            },
            deadline_color: {
                name: 'deadline_color', 
                type: "Int",
                label: 'Kiểm tra gần hết hạn',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            is_late: {
                name: 'is_late', 
                type: "Boolean",
                label: 'Văn bản đã trễ',
                display: false
            },
                date_month_td: {
                    name: 'date_month_td',
                    type: "Date",
                    label: 'Ngày tháng TĐ',
                    width:13,
                    class: "center",
                    filter: { type: 'DateRange', match: 'custom'},
                     display: false
                },
        },)
    }

}